// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ads-container {
  padding: 24px;
}

.page-header {
  margin-bottom: 24px;
}

.page-header .ant-typography {
  margin-bottom: 8px;
}

.table-header {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-header .ant-space {
  flex: 1 1;
}

.ant-table-wrapper {
  background: #fff;
  border-radius: 8px;
}

.ant-table-thead > tr > th {
  background: #fafafa;
  font-weight: 600;
}

.ant-table-tbody > tr:hover > td {
  background: #f5f5f5;
}

.ant-modal-content {
  border-radius: 8px;
}

.ant-form-item-label > label {
  font-weight: 500;
}

.ant-input,
.ant-input-textarea {
  border-radius: 6px;
}

.ant-btn {
  border-radius: 6px;
}

.ant-tag {
  border-radius: 4px;
  font-weight: 500;
}

.ant-alert {
  border-radius: 8px;
}

.ant-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.ant-card-head {
  border-bottom: 1px solid #f0f0f0;
}

.ant-table-pagination {
  margin: 16px 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .ads-container {
    padding: 16px;
  }
  
  .table-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .table-header .ant-space {
    justify-content: center;
  }
  
  .ant-table {
    font-size: 12px;
  }
  
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px 4px;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/Admin/Ads/Ads.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":[".ads-container {\n  padding: 24px;\n}\n\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-header .ant-typography {\n  margin-bottom: 8px;\n}\n\n.table-header {\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.table-header .ant-space {\n  flex: 1;\n}\n\n.ant-table-wrapper {\n  background: #fff;\n  border-radius: 8px;\n}\n\n.ant-table-thead > tr > th {\n  background: #fafafa;\n  font-weight: 600;\n}\n\n.ant-table-tbody > tr:hover > td {\n  background: #f5f5f5;\n}\n\n.ant-modal-content {\n  border-radius: 8px;\n}\n\n.ant-form-item-label > label {\n  font-weight: 500;\n}\n\n.ant-input,\n.ant-input-textarea {\n  border-radius: 6px;\n}\n\n.ant-btn {\n  border-radius: 6px;\n}\n\n.ant-tag {\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.ant-alert {\n  border-radius: 8px;\n}\n\n.ant-card {\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.ant-card-head {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.ant-table-pagination {\n  margin: 16px 0;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .ads-container {\n    padding: 16px;\n  }\n  \n  .table-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .table-header .ant-space {\n    justify-content: center;\n  }\n  \n  .ant-table {\n    font-size: 12px;\n  }\n  \n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 8px 4px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
